/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./AcInfo.css";
import { simpleFetch } from "../../restWrapper";
import { isEmpty } from "../../assets/validators/common.js";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

class AcInfo extends Component {
  constructor(props) {
    super(props);
    this.onLogoutClick = this.onLogoutClick.bind(this);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    simpleFetch("/donors", "GET").then((res) => {
      if (res.status !== 200 || !res.body) {
        this.props.logout();
        this.props.history.push({
          pathname: "/",
        });
        return null;
      }
      let donorDataObj = res.body;

      const customer = donorDataObj.customer;
      donorDataObj.customer = undefined;
      this.setState({
        loading: false,
        donor: {
          ...donorDataObj,
          ...customer,
        },
        color: this.props.location.state.color,
      });
    });
  }

  onLogoutClick() {
    this.props.logout().then((res) => {
      if (res.status === 204) {
        this.props.history.push({ pathname: "/" });
      }
    });
  }

  render() {
    if (this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }

    //    const color = this.state.color;

    const backgroundOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    const color = this.props.location.state.color;

    const organizationName = this.props.location.state.organizationName;

    return (
      <div className="AcInfo-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="AcInfo-bg" style={backgroundOverrideStyle} />
        <div className="AcInfo-container">
          <div className="AcInfo-header">
            <div className="AcInfo-headingText">
              {this.props.languageObj.headingText}
            </div>

            <Link to="/SelectMission">
              <div className="AcInfo-backContainer">
                <div className="AcInfo-back">
                  <div className="AcInfo-backBtn"></div>
                  <div className="AcInfo-backText">
                    {this.props.languageObj.backBtn}
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to={{
                pathname: "/AcInfoEdit",
                state: {
                  ...this.state,
                  color: color,
                  organizationName: organizationName,
                },
              }}
            >
              <div className="AcInfo-editContainer">
                <div className="AcInfo-edit">
                  {this.props.languageObj.editBtn}
                </div>
              </div>
            </Link>
          </div>

          <div className="AcInfo-main">
            <RenderDonorItems
              donorData={this.state.donor}
              languageObj={this.props.languageObj}
            />
            <div className="AcInfo-bottomToolbar">
              <Link
                to={{
                  pathname: "/ChangePassword",
                  state: {
                    color: color,
                    organizationName: organizationName,
                  },
                }}
              >
                <div className="AcInfo-passwordContainer">
                  <div className="AcInfo-passwordIcn"></div>
                </div>
              </Link>

              <div
                className="AcInfo-logoutContainer"
                onClick={this.onLogoutClick}
              >
                <div className="AcInfo-logoutIcn"></div>
              </div>

              <Link
                to={{
                  pathname: "/DeleteAccount",
                  state: {
                    color: color,
                    organizationName: organizationName,
                  },
                }}
              >
                <div className="AcInfo-deleteContainer">
                  <div className="AcInfo-deleteIcn"></div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const RenderDonorItems = (props) => {
  if (!props.donorData) return null;
  const dataObj = props.donorData;
  const languageObj = props.languageObj.inputContainer;
  const orderOfItems = [
    "name",
    "username",
    "phoneNumber",
    "ageGroup",
    "birthdayDay",
    "location",
  ];

  const HandleItems = (props) => {
    if (!props.item) return null;
    let showText = "";
    const item = props.item;
    const RenderItem = (props) => {
      if (!props || isEmpty(props.showText)) return null;
      return (
        <div className="AcInfo-item">
          {languageObj[item]}
          <div className="AcInfo-answer">{props.showText}</div>
        </div>
      );
    };

    switch (item) {
      case orderOfItems[0]:
        showText = dataObj.lastName + " " + dataObj.firstName;
        break;
      case orderOfItems[3]:
        return null;
      case orderOfItems[4]:
        return null;
      //  showText = dataObj.birthdayDayInMonth + ' ' + dataObj.birthdayMonth
      //break;
      // case orderOfItems[5]:
      // showText = dataObj.flatAndFloorNumber + ' ' +
      // dataObj.building + ' ' +
      // dataObj.street + ' ' +
      // dataObj.town + ' ' +
      // dataObj.country;
      default:
        return <RenderItem showText={dataObj[item]} />;
    }
    return <RenderItem showText={showText} />;
  };

  return (
    <div className="AcInfo-inputContainer">
      {orderOfItems.map((item) => (
        <HandleItems key={item} item={item} />
      ))}
    </div>
  );
};

RenderDonorItems.propTypes = {
  donorData: PropTypes.object,
  languageObj: PropTypes.object,
  item: PropTypes.object,
  showText: PropTypes.string,
};

AcInfo.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
  logout: PropTypes.func,
};

export default AcInfo;
